'use client'

import styled from "styled-components";
import BaseInput from "@/components/UI/Form/Inputs/BaseInput/BaseInput";

export const PasswordInputStyled = styled(BaseInput)``

export const PasswordToggleIcon = styled.span`
    position: absolute;
    right: 15px;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
    cursor: pointer;
    color: rgba(0, 0, 0, 0.45);
    z-index: 2;
`